import { render } from "./VPN.vue?vue&type=template&id=3b34d410"
import script from "./VPN.vue?vue&type=script&lang=js"
export * from "./VPN.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__